/**
 * @FileDescription: 流程-审批流程-配置
 * @Author: qiaofeng
 * @Date: 2021-07-14
 * @LastEditors: qiaofeng
 * @LastEditTime: 2021-07-14 
 */
import axios from '@/api/utils/axios';
import BaseApi from '@/api/utils/baseApi.js'

const DeployApi = {
	/**
	 * @description: 基础地址
	 */
	baseUrl: function() {
		return '/longstron/workflow/wfs/def/deploy';
	},
	/**
	 * @description: 获取审批信息数据
	 * @param {String} deployId 流程发布id
	 */
	getDeployData: function(deployId) {
		return axios.post(this.baseUrl() + "/" + deployId + "/activities");
	},
	/**
	 * @description: 根据资源code获取业务流程
	 * @param {String} permissionCode 资源code
	 */
	getDeployList: function(permissionCode) {
		return axios.get(this.baseUrl() + '/list/by/' + permissionCode);
	},
};

export default Object.assign(DeployApi, BaseApi);
